.carousel {

  width: 100%;



  ul
  {
    flex-direction: row;
  }

  .slide {
    //padding: 40px;

    max-height: 400px;
    height: 100%;
    cursor: zoom-in;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }


}

.fullscreen {

  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 300;

  .tools {
    position: absolute;
    right: 10px;
    top: 10px;

    text-align: center;
    z-index: 201;
    display: flex;
    gap: 10px;

    & > * {
      width: 40px;
      height: 40px;
      border: 2px solid var(--beigedarker);

      display: inline-flex;
      justify-content: center;
      cursor: pointer;
    }
    .close {

    }
  }


  .carousel {
    .slide {
      max-height: inherit;
      height: calc(100vh - 1.5em);
      cursor: zoom-out;
      margin: 0.75em;
    }
  }

}
